// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 验证原手机号（客户端换绑） POST /api/v1/app-user/change-phone/verify-old */
export async function AppUserControllerVerifyOldPhoneV1(
  body: MyApi.VerifyClientOldPhoneDto,
  options?: { [key: string]: any }
) {
  return request<{ code: number; message: string; data: null }>(
    "/api/v1/app-user/change-phone/verify-old",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 修改绑定手机号（客户端） PUT /api/v1/app-user/change-phone */
export async function AppUserControllerChangePhoneV1(
  body: MyApi.ClientChangePhoneDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputUserDto>(
    "/api/v1/app-user/change-phone",
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 更新用户身份证信息 PUT /api/v1/app-user/id-card */
export async function AppUserControllerUpdateIdCardV1(
  body: MyApi.UpdateUserIdCardDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputUserDto>("/api/v1/app-user/id-card", {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取当前用户信息 GET /api/v1/app-user/me */
export async function AppUserControllerGetCurrentUserV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputUserDto>("/api/v1/app-user/me", {
    method: "GET",
    ...(options || {}),
  });
}

/** 更新用户资料 PUT /api/v1/app-user/profile */
export async function AppUserControllerUpdateProfileV1(
  body: MyApi.UpdateUserProfileInfoDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputUserDto>("/api/v1/app-user/profile", {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
